<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="state.modalTitle" :width="'70%'" :open="true" :confirmLoading="state.loading" @ok="onFormSubmit"
        @cancel="
            () => {
                emit('cancel')
            }
        ">
        <a-spin :spinning="state.loading">
            <a-form ref="ruleForm" :model="formState" :rules="rules" :label-col="{ span: 6 }"
                :wrapper-col="{ span: 18 }" class="compact-form">
                <!-- ============ 第一行：项目目的（单独一行） ============ -->
                <a-row :gutter="16">
                    <a-col :span="24">
                        <a-form-item label="项目目的" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                            <a-radio-group v-model:value="formState.type"
                                :options="templateFileTypeOptions"></a-radio-group>
                        </a-form-item>
                    </a-col>
                </a-row>

                <!-- ============ 第二行：项目名称 + 归属平台 ============ -->
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="项目名称" name="name" required>
                            <a-input placeholder="请输入项目名称" v-model:value="formState.name"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="归属平台" name="platform_id">
                            <PlatformPick v-model:value="formState.platform_id"></PlatformPick>
                        </a-form-item>
                    </a-col>
                </a-row>

                <!-- ============ 第三行：项目收集时间 + 接收邮箱 ============ -->
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="项目收集时间" name="startAndEnd_time" required>
                            <a-range-picker style="width: 100%" :show-time="{ defaultValue: arrayMonent }"
                                :value="rangTime" @change="rangTimeChange" :format="format"></a-range-picker>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="接收邮箱">
                            <a-input placeholder="请输入项目接收邮箱" v-model:value="formState.mail"></a-input>
                        </a-form-item>
                    </a-col>
                </a-row>

                <!-- ============ 第四行：负责人姓名 + 负责人电话 ============ -->
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="负责人姓名" name="responsible_person_name" required>
                            <a-input placeholder="请输入负责人姓名" v-model:value="formState.responsible_person_name"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="负责人电话" name="responsible_person_tel" required>
                            <a-input placeholder="请输入负责人电话" v-model:value="formState.responsible_person_tel"></a-input>
                        </a-form-item>
                    </a-col>
                </a-row>

                <!-- ============ 第五行：项目说明（整行） ============ -->
                <a-row :gutter="16">
                    <a-col :span="24">
                        <a-form-item label="项目说明" name="remark" required :label-col="{ span: 3 }"
                            :wrapper-col="{ span: 21 }">
                            <a-textarea :rows="2" placeholder="请输入项目说明" v-model:value="formState.remark"></a-textarea>
                        </a-form-item>
                    </a-col>
                </a-row>

                <!-- ============ 第六行：复制内容（整行） ============ -->
                <a-row :gutter="16">
                    <a-col :span="24">
                        <a-form-item label="复制内容" name="copy_content" required :label-col="{ span: 3 }"
                            :wrapper-col="{ span: 21 }">
                            <a-textarea :rows="5" placeholder="请输入复制内容"
                                v-model:value="formState.copy_content"></a-textarea>
                            <div class="tip-text">插入“##主体名称##”，“##法人代表姓名##” 进行替换，可将放在适合的位置</div>
                        </a-form-item>
                    </a-col>
                </a-row>

                <!-- ======================= 参与主体（二选一） + 项目相关附件 ======================= -->
                <a-row :gutter="16">
                    <!-- 左侧：参与主体 -->
                    <a-col :span="12">
                        <a-form-item label="参与主体">
                            <!-- 方式切换 -->
                            <div class="subject-mode-switch">
                                <a-radio-group v-model:value="formState.subject_mode" button-style="solid">
                                    <a-radio-button value="manual">手动筛选</a-radio-button>
                                    <a-radio-button value="upload">上传表格</a-radio-button>
                                </a-radio-group>
                                <span class="tip-text" style="margin-left: 12px">
                                    两种方式任选其一
                                </span>
                            </div>

                            <!-- 方式一：手动筛选 -->
                            <div v-if="formState.subject_mode === 'manual'" style="margin-top: 8px">
                                <SelectCompany :isEdit="state.isEdit" :selectCheck="formState.customer_infos"
                                    @change="SelectCompanyChange"></SelectCompany>
                            </div>

                            <!-- 方式二：上传表格 -->
                            <div v-if="formState.subject_mode === 'upload'" style="margin-top: 8px">
                                <Upload upload_path="public/uploads/特别行动" uploadType="text"
                                    :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']"
                                    :limitation="1" v-model:value="formState.import_url" uploadText="上传参与主体表格">
                                </Upload>
                                <a class="tip-link"
                                    href="https://hncs.cskaiyela.com/storage/public/uploads/manage/特别行动/模版库/专项行动站外客户导入模板.xlsx"
                                    target="_blank">查看主体模板</a>
                            </div>
                        </a-form-item>
                    </a-col>

                    <!-- 右侧：项目相关附件 -->
                    <a-col :span="12">
                        <a-form-item label="项目相关附件">
                            <Upload upload_path="public/uploads/特别行动" uploadType="text"
                                :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png', 'zip', 'rar', '7z']"
                                :limitation="99" v-model:value="formState.document" uploadText="上传附件">
                            </Upload>
                        </a-form-item>
                    </a-col>
                </a-row>
                <!-- ======================= 参与主体结束 ======================= -->

                <!-- ======================= 专项行动字段收集（整行） ======================= -->
                <a-row :gutter="16">
                    <a-col :span="24">
                        <a-form-item label="字段收集配置" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                            <div class="custom-field-wrapper">
                                <!-- 循环渲染每一个自定义字段 -->
                                <div v-for="(item, index) in formState.custom_fields" :key="index"
                                    class="custom-field-item">
                                    <!-- 序号 -->
                                    <span class="field-index">{{ index + 1 }}</span>

                                    <!-- 字段名称 -->
                                    <a-input v-model:value="item.label" placeholder="字段名称" class="field-label" />

                                    <!-- 控件类型 -->
                                    <a-select v-model:value="item.type" class="field-type">
                                        <a-select-option v-for="opt in fieldTypeOptions" :key="opt.value"
                                            :value="opt.value">
                                            {{ opt.label }}
                                        </a-select-option>
                                    </a-select>

                                    <!-- 选项内容（仅单选/多选显示） -->
                                    <a-input v-if="item.type === 'radio' || item.type === 'checkbox'"
                                        v-model:value="item.options" placeholder="选项用逗号分隔，如：男,女"
                                        class="field-options" />

                                    <!-- 提示文字 -->
                                    <a-input v-model:value="item.placeholder" placeholder="提示文字"
                                        class="field-placeholder" />

                                    <!-- 默认值 -->
                                    <a-input v-model:value="item.default_value" placeholder="默认值"
                                        class="field-default" />

                                    <!-- 是否必填 -->
                                    <a-checkbox v-model:checked="item.required" class="field-required">
                                        必填
                                    </a-checkbox>

                                    <!-- 删除按钮 -->
                                    <a-button type="link" danger size="small" class="field-delete"
                                        @click="removeCustomField(index)">
                                        删除
                                    </a-button>
                                </div>

                                <!-- 添加按钮 + 提示 -->
                                <div class="custom-field-footer">
                                    <a-button type="dashed" size="small" @click="addCustomField">
                                        + 添加字段
                                    </a-button>
                                    <span class="custom-field-tip">
                                        字段名称用于生成收集表单，如"姓名"、"身份证号"、"上传证件"
                                    </span>
                                </div>
                            </div>
                        </a-form-item>
                    </a-col>
                </a-row>
                <!-- ======================= 新增结束 ======================= -->
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { SelectCompany, Upload } from '@/components'
import { mobileRequiredValidator } from '@/utils/util'
import PlatformPick from '@/components/base/PlatformPick.vue'
import dayjs from 'dayjs'

const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
const format = 'YYYY-MM-DD HH:mm:ss'

const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})

const templateFileTypeOptions = [
    { label: '收集附件', value: 1 },
    { label: '工商年检', value: 2 }
]

// ============ 字段类型可选项（含多行文本） ============
const fieldTypeOptions = [
    { label: '输入框', value: 'input' },
    { label: '多行文本', value: 'textarea' },
    { label: '文件', value: 'file' },
    { label: '单选', value: 'radio' },
    { label: '多选', value: 'checkbox' }
]

const emit = defineEmits(['cancel'])
const ruleForm = ref()

const rules = {
    responsible_person_tel: [{ required: true, validator: mobileRequiredValidator }]
}

interface state {
    modalTitle: string
    loading: boolean
    isEdit: boolean
}

const state = reactive<state>({
    modalTitle: '新增项目',
    loading: false,
    isEdit: false
})

// 自定义字段类型定义
interface CustomField {
    label: string
    type: 'input' | 'textarea' | 'file' | 'radio' | 'checkbox'
    options?: string
    required?: boolean
    placeholder?: string   // 新增
    default_value?: string // 新增
}

// 参与主体模式：manual=手动筛选，upload=上传表格
type SubjectMode = 'manual' | 'upload'

interface formState {
    name: string
    customer_infos: any[]
    import_url: any[] | undefined
    type: number
    document: any[] | undefined
    remark: string
    responsible_person_name: string
    responsible_person_tel: string
    mail: string
    startAndEnd_time: string | null
    copy_content: string | null
    platform_id: number | undefined
    subject_mode: SubjectMode
    custom_fields: CustomField[]
}

let formState = reactive<formState>({
    name: '',
    customer_infos: [],
    import_url: undefined,
    type: 1,
    document: undefined,
    remark: '',
    responsible_person_name: '',
    responsible_person_tel: '',
    mail: '',
    startAndEnd_time: '',
    copy_content: '',
    platform_id: undefined,
    subject_mode: 'manual',
    custom_fields: []
})

const rangTime = computed(() => {
    let array: any = []
    if (formState.startAndEnd_time) {
        const startAndEnd_time = formState.startAndEnd_time.split(',')
        array = startAndEnd_time.map((item) => dayjs(item ? item : null, format))
    } else {
        array = []
    }
    return array
})

const rangTimeChange = (val, str) => {
    if (val) {
        formState.startAndEnd_time = str.join(',')
    } else {
        formState.startAndEnd_time = null
    }
}

onMounted(() => {
    if (props.detailData?.id) {
        state.modalTitle = '编辑项目'
        state.isEdit = true
        queryDetail(props.detailData.id)
    }
})

const queryDetail = (id) => {
    state.loading = true
    let requeryParam = {
        url: `/admin/v1/specificProjec/${id}/edit`,
        method: 'get'
    }
    baseService(requeryParam).then((res) => {
        state.loading = false
        Object.assign(formState, res.data)
        if (!formState.custom_fields) {
            formState.custom_fields = []
        }
        if (!formState.subject_mode) {
            formState.subject_mode =
                formState.import_url && formState.import_url.length > 0 ? 'upload' : 'manual'
        }
    })
}

const SelectCompanyChange = (val: any[]) => {
    formState.customer_infos = [...val]
}

// 添加字段
const addCustomField = () => {
    formState.custom_fields.push({
        label: '',
        type: 'input',
        options: '',
        required: false,
        placeholder: '',    // 新增
        default_value: ''   // 新增
    })
}

// 删除字段
const removeCustomField = (index: number) => {
    formState.custom_fields.splice(index, 1)
}

const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            const hasEmptyLabel = formState.custom_fields.some((item) => !item.label)
            if (hasEmptyLabel) {
                message.error('字段收集配置中存在未填写名称的字段，请检查')
                return
            }

            // ============ 参与主体二选一：提交前清空另一种方式的数据 ============
            const submitData: any = { ...formState }
            if (formState.subject_mode === 'manual') {
                submitData.import_url = undefined
            } else {
                submitData.customer_infos = []
            }

            state.loading = true
            if (props.detailData?.id > 0) {
                let requeryParam = {
                    url: '/admin/v1/specificProjec/' + props.detailData.id,
                    method: 'put',
                    data: submitData
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('cancel')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            } else {
                let requeryParam = {
                    url: '/admin/v1/specificProjec',
                    method: 'post',
                    data: submitData
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('cancel')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            }
        })
        .catch(() => { })
}
</script>

<style lang="less" scoped>
/* ========== 表单整体间距 ========== */
.compact-form {
    :deep(.ant-form-item) {
        margin-bottom: 20px;
    }
}

/* 提示文字 */
.tip-text {
    color: #999;
    font-size: 12px;
    margin-top: 4px;
}

.tip-link {
    margin-left: 8px;
    font-size: 12px;
}

/* 参与主体切换区 */
.subject-mode-switch {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

/* ========== 字段收集配置区域 ========== */
.custom-field-wrapper {
    width: 100%;
}

/* 每一行字段：顺序排列，放不下自动换行 */
.custom-field-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 8px;
    margin-bottom: 6px;
    background: #fafafa;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    flex-wrap: wrap;
    /* 关键：一行放不下自动换行 */
}

/* 序号 */
.field-index {
    display: inline-block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    background: #1677ff;
    border-radius: 50%;
    flex-shrink: 0;
}

/* 字段名称 */
.field-label {
    width: 150px;
    flex-shrink: 0;
}

/* 控件类型 */
.field-type {
    width: 110px;
    flex-shrink: 0;
}

/* 选项输入 */
.field-options {
    width: 200px;
    flex-shrink: 0;
}

/* 提示文字 */
.field-placeholder {
    width: 150px;
    flex-shrink: 0;
}

/* 默认值 */
.field-default {
    width: 150px;
    flex-shrink: 0;
}

/* 必填 */
.field-required {
    flex-shrink: 0;
    font-size: 12px;
    white-space: nowrap;
}

/* 删除按钮 */
.field-delete {
    flex-shrink: 0;
    padding: 0 4px;
}

/* 底部：添加按钮 + 提示 */
.custom-field-footer {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 4px;
}

.custom-field-tip {
    color: #999;
    font-size: 12px;
}

/* 提示文字输入 */
.field-placeholder {
    width: 140px;
    flex-shrink: 0;
}

/* 默认值输入 */
.field-default {
    width: 140px;
    flex-shrink: 0;
}
</style>
